import { ApiType } from "@gymflow/common";
import { LeadSourceCreateDTO } from "@gymflow/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { leadSourceQueryKeys } from "./leadSourceQueryKeys";

export function useLeadSourceCreate({ api }: { api: ApiType }) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (newLeadSource: LeadSourceCreateDTO) => {
      return (await api.leadSourceApi.create(newLeadSource)).data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: leadSourceQueryKeys.all() });
    },
  });
}
